module.exports = __webpack_public_path__ + "static/media/excel@3x.807d2b45.png";